import axios from "axios";

const apiClient = axios.create({
   validateStatus: function (status) {
       return (status >= 200 && status < 300) || status == 400;
   },
});

export default apiClient;
